
import React from 'react';
import { Display } from '@/types/sequence';
import DisplayCard from '@/components/displays/DisplayCard';

interface DisplayWithOwner extends Display {
  isFavorite: boolean;
  owner?: {
    name: string;
    avatar: string;
  };
  songCount: number;
}

interface DisplayCategoriesProps {
  displayItems: DisplayWithOwner[];
}

const DisplayCategories = ({
  displayItems,
}: DisplayCategoriesProps) => {
  return (
    <div className="mb-8">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {displayItems.map(display => (
          <DisplayCard 
            key={display.id} 
            display={display}
          />
        ))}
      </div>
      
      {displayItems.length === 0 && (
        <div className="text-center py-12">
          <h3 className="text-xl font-medium mb-2">No displays found</h3>
          <p className="text-muted-foreground">Try adjusting your search or filters</p>
        </div>
      )}
    </div>
  );
};

export default DisplayCategories;
